import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 p-6 text-center">
        <h1 className="text-2xl font-semibold">Something went wrong.</h1>
        <p className="text-sm text-muted-foreground max-w-md">
          {this.state.error.message || "Unexpected error."}
        </p>
        <button
          onClick={() => {
            this.setState({ error: null });
            window.location.assign("/");
          }}
          className="mt-4 inline-flex items-center justify-center rounded-md border bg-background px-4 py-2 text-sm shadow-xs hover:bg-accent"
        >
          Reload home
        </button>
      </div>
    );
  }
}
